var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "site header", attrs: { role: "banner" } },
    [
      _c("div", { staticClass: "ux container" }, [
        _c("div", { staticClass: "d-flex align-items-stretch" }, [
          _c(
            "div",
            {
              staticClass: "d-flex flex-column justify-content-stretch m-0 p-0"
            },
            [
              _c(
                "div",
                { staticClass: "d-block m-0 p-0" },
                [
                  _c("content-item", {
                    staticClass: "m-0 p-0",
                    attrs: { "bundle-name": "Header", "item-key": "LOGO_LEFT" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column justify-content-center p-0" },
            [
              _c(
                "div",
                { staticClass: "d-block m-0 p-0" },
                [
                  _c("content-item", {
                    staticClass: "m-0 p-0",
                    attrs: { "bundle-name": "Header", "item-key": "LOGO_RIGHT" }
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "d-flex flex-column justify-content-stretch mx-3",
        staticStyle: {
          "margin-top": "1rem !important",
          "margin-bottom": "1rem !important"
        }
      },
      [
        _c("div", {
          staticClass: "border-left border-secondary h-100",
          staticStyle: {
            "border-left-color": "#CCD3E0 !important",
            "border-left-width": "1.5px !important"
          }
        })
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-041d2fee", { render: render, staticRenderFns: staticRenderFns })
  }
}